<mat-card [ngStyle]="panelStyle">
  <mat-card-header *ngIf="panelTitle">
    <mat-card-title>{{ panelTitle }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
